import FreshmanAdminApproval from "../../apiServices/common/freshmanAdminApprovalService";
import { emailVerificationStatus } from "../../constants/emailVerificationStatus";
import { setFreshmanProcessResponse } from "../../store/slices/common/commonSlice";

export function getProcessApproval(token: string) {
    return async function (dispatch: any, getState: any) {
        try {
            let response = await FreshmanAdminApproval.getProcessApproval(token);
            if (response?.success === true) {
                if (response.message === emailVerificationStatus.Approved) {
                    dispatch(setFreshmanProcessResponse(emailVerificationStatus.Approved));
                } else if (response.message === emailVerificationStatus.Rejected) {
                    dispatch(setFreshmanProcessResponse(emailVerificationStatus.Rejected));
                }
            } else {
                dispatch(setFreshmanProcessResponse(emailVerificationStatus.Invalid_Token));
            }
        } catch (error) {
            dispatch(setFreshmanProcessResponse(emailVerificationStatus.Error));
        }
    };
}
